import PropTypes from 'prop-types';
import { createContext } from 'react';
const UsageTrackerContext = /*#__PURE__*/createContext({
  immediateUsageTracker: null,
  usageTracker: null
});
UsageTrackerContext.displayName = 'UsageTrackerContext';
export const UsageTrackerShape = PropTypes.shape({
  clone: PropTypes.func.isRequired,
  setProperties: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired
});
UsageTrackerContext.Provider.propTypes = {
  value: PropTypes.shape({
    immediateUsageTracker: UsageTrackerShape,
    usageTracker: UsageTrackerShape.isRequired
  }).isRequired
};
export const UsageTrackerProvider = UsageTrackerContext.Provider;
export const UsageTrackerConsumer = UsageTrackerContext.Consumer;
export default UsageTrackerContext;